<template>
  <div class="w-screen h-screen grid overflow-hidden" :class="userStore.mainNavBarVisibility ? 'grid-cols-nav-content' : 'grid-cols-1'">
    <main-nav-bar v-show="userStore.mainNavBarVisibility" />
    <slot />
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '@/store/userData'
import MainNavBar from '@/shared/components/MainNavBar.vue'

const userStore = useUserStore()
</script>
